import React from "react";
import {connect} from "react-redux";

import Fade from "@mui/material/Fade";
import LookAILoadingBar from "./LookAILoadingBar";


const LookAILoadingPanel = ({aiLoading}) => {
  return (
    <Fade in={aiLoading} timeout={300} unmountOnExit>
      <div className="fixed left-1/2 -translate-x-1/2 bottom-25 w-full" style={{
        maxWidth: "340px",
        zIndex: 40,
      }}>
        <LookAILoadingBar styles={{
          background: "rgba(255, 255, 255, 0.5)"
        }}/>
      </div>
    </Fade>
  );
}


const mapStateToProps = (store) => {
  const {aiLoading} = store.aiState;
  return {
    aiLoading,
  };
};

export default connect(mapStateToProps)(LookAILoadingPanel)
